import axios from 'axios';

let semifinishedProductsCancelSource;

export default {
    overviewDeliveredSemifinishedProducts(payload) {
        if (semifinishedProductsCancelSource) {
            semifinishedProductsCancelSource.cancel();
        }
        semifinishedProductsCancelSource = axios.CancelToken.source();

        return axios.post(
            '/product/overviewDeliveredSemifinishedProducts/',
            payload,
            {
                cancelToken: semifinishedProductsCancelSource.token,
            }
        );
    },
    processDelivered(productNr, boxnr, colli, stockLocations) {
        return axios.post('/product/processDeliveredSemifinishedProduct/', {
            productNr,
            boxnr,
            colli: colli || '',
            stockLocations,
        });
    },
    batchSaveColliAndLocations(products) {
        return axios.post('/product/batchSaveColliAndLocations', { products });
    },
    descriptionForProduct(productId) {
        return axios.post('/product/descriptionForProduct', { productId });
    },
    fetchExtendedDetails(productId) {
        return axios.post('/product/productExtendedDetails/', {
            productNr: productId,
        });
    },
    fetchProductBatch(productNr) {
        return axios.post('/product/fetchProductBatch', { productNr });
    },
    fetchProductsBatchByPaintworkform(paintworkformId) {
        return axios.post('/product/fetchProductsBatchByPaintworkform', {
            paintworkformId,
        });
    },
    fetchProductsBatchByLakbon(lakbonId) {
        return axios.post('/product/fetchProductsBatchByLakbon', {
            lakbonId,
        });
    },
    fetchProductGroup(productId) {
        return axios.post('/product/productgroup', { productNr: productId });
    },
    fetchOrder(productId) {
        return axios.post('/product/fetchOrder', { productId });
    },
    fetchProductDetails(productId, extraOptimizedPaintlistsInfo) {
        return axios.post('/product/productDetails/', {
            productId,
            extraOptimizedPaintlistsInfo,
        });
    },
    fetchShallowProduct(productId) {
        return axios.post('/product/shallowProduct/', { productId });
    },
    rules(id) {
        return axios.post('/product/rules/', { id });
    },
    rulesEdit(id) {
        return axios.post('/product/rulesEdit/', { id });
    },
    saveRules(id, conditions, sawlines) {
        return axios.post('/product/saveRules/', {
            id,
            conditions,
            sawlines,
        });
    },
    validateProductExistence(productNr) {
        return axios.post('/product/validateProductExistence/', { productNr });
    },
    productsForOrderV2(orderId) {
        return axios.post('/product/productsForOrderV2/', { orderId });
    },
    history(productId) {
        return axios.post('/product/history/', { productId });
    },
    editProductGroup(productGroupId, colorId) {
        return axios.post('/product/editProductGroup/', {
            productGroupId,
            color: colorId,
        });
    },
    sawn(productId, employeeId) {
        return axios.post('/product/sawn/', { productId, employeeId });
    },
    drilled(productId, employeeId) {
        return axios.post('/product/drilled/', { productId, employeeId });
    },
    getAdditionalInfo(productId) {
        return axios.post('/product/getAdditionalInfo/', { productId });
    },
    editOverview(payload) {
        return axios.post('/product/editoverview/', payload);
    },
    updateProductionDate(productId, productionDate) {
        return axios.post('/product/updateProductionDate/', {
            productId,
            productionDate,
        });
    },
    updatePrice(productId, price) {
        return axios.post('/product/updatePrice/', { productId, price });
    },
    getTimeSpent(userId, date, length) {
        return axios.post('/product/getTimeSpent/', {
            userId,
            date,
            length,
        });
    },
    updateManualCheck(productId, manualCheck) {
        return axios.post('/product/updateManualCheck/', {
            productId,
            manualCheck,
        });
    },
    productsToProduction(orderId) {
        return axios.post('/product/productsToProduction/', { orderId });
    },
    addProduct(payload) {
        return axios.post('/product/addProduct/', payload);
    },
    editProduct(payload) {
        return axios.post('/product/editProduct/', payload);
    },
    remove(productId) {
        return axios.post('/product/remove/', { productId });
    },
    isGroup(productId) {
        return axios.post('/product/isGroup/', { productId });
    },
    setAdditionalInfoToProduct(
        productId,
        boxnr,
        colli,
        productionDate,
        repairReasonId,
        internUrl,
        externUrl,
        stockLocations
    ) {
        return axios.post('/product/setAdditionalInfo/', {
            productNr: productId,
            boxnr: boxnr || '',
            colli,
            repairReasonId,
            productionDate,
            internUrl,
            externUrl,
            stockLocations,
        });
    },
    problem(productId, boxnr, colli, repairreasonId) {
        return axios.post('/product/problem/', {
            productId,
            boxnr,
            colli,
            repairreasonId,
        });
    },
    done(productId, boxnr, colli) {
        return axios.post('/product/done/', {
            productId,
            boxnr,
            colli,
        });
    },
    addServiceOrderProduct(payload) {
        return axios.post('/product/addServiceOrderProduct/', payload);
    },
    updateProductProperty(productId, prop, value) {
        return axios.post('/product/updateProductProperty', {
            productId,
            prop,
            value,
        });
    },
    listProductLists(productId) {
        return axios.get('[API]/productlist/list-by-product/' + productId);
    },
    exportByProductType(
        productTypeId,
        earliestAllowedOrderDateTime,
        latestAllowedOrderDateTime
    ) {
        return axios.get(
            `[API]/product/export-by-product-type/${productTypeId}`,
            {
                params: {
                    earliest_allowed_order_datetime:
                        earliestAllowedOrderDateTime,
                    latest_allowed_order_datetime: latestAllowedOrderDateTime,
                },
            }
        );
    },
    storeValueFields(productId, valueFields) {
        return axios.post(`[API]/products/${productId}/value-fields`, {
            valueFields: Object.entries(valueFields).map(([key, value]) => ({
                dataFieldId: key,
                value,
            })),
        });
    },
    uploadProductImage(file, productId, onUploadProgress) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('product', productId);
    
        const config = {};
    
        if (onUploadProgress) {
            config.onUploadProgress = onUploadProgress;
        }
    
        return axios.put('[API]/products/image', formData, config);
    },
};
